import { api } from './client';
import type { WorkspacePayload } from '../types/workspace';
import { queryKeys } from '../queryKeys';
import { queryClient } from '../queryClient';

export async function fetchWorkspace(
  projectId: number,
  opts?: { blueprintId?: number | null; tabId?: number | null }
): Promise<WorkspacePayload> {
  const params = new URLSearchParams();
  if (opts?.blueprintId) params.set('blueprint_id', String(opts.blueprintId));
  if (opts?.tabId) params.set('tab_id', String(opts.tabId));
  const query = params.toString();
  return api<WorkspacePayload>(
    `/api/projects/${projectId}/workspace/${query ? `?${query}` : ''}`
  );
}

export function workspaceQueryOptions(
  projectId: number,
  blueprintId?: number | null,
  tabId?: number | null
) {
  return {
    queryKey: queryKeys.workspace(projectId, blueprintId, tabId),
    queryFn: () => fetchWorkspace(projectId, { blueprintId, tabId }),
    staleTime: 30_000,
  };
}

export function invalidateWorkspaceQueries(projectId: number) {
  return queryClient.invalidateQueries({ queryKey: queryKeys.workspaceRoot(projectId) });
}
